export default {
    data() {
        return {
            timeOffset: '2023/08/31 13:30:00',
            type: 0,
            typeBits: 4,
            numBits: 10,
        }
    },
    methods: {
        getDataId() {
            const time = Math.floor(new Date().getTime() / 1000);
            const timeOffset = Math.floor(new Date(this.timeOffset).getTime() / 1000);
            const max = -1 ^ (-1 << this.numBits);
            const rand = Math.floor(Math.random() * (max - 1));
            // eslint-disable-next-line no-undef
            const num = BigInt(time - timeOffset) << BigInt(this.typeBits + this.numBits) | BigInt(this.type << this.typeBits) | BigInt(rand);
            return num.toString();
        },
        addItem (index) {
            this.form.list.splice(index + 1, 0, {id: this.getDataId()})
        },
        removeItem (index) {
            if (this.form.list.length > 1) {
                this.form.list.splice(index, 1)
            } else {
                this.form.list.splice(index, 1, {id: this.getDataId()})
            }
        },
    }
}